import type { SlaRowVM } from '../../view-models';
import type React from 'react';

export function SlaCategoryRow({
  sla,
  onDrill,
}: {
  sla: SlaRowVM;
  onDrill?: (sla: SlaRowVM) => void;
}): React.JSX.Element {
  const ok = sla.status === 'ok';
  return (
    <div className={'sla-row sla-row--' + sla.status}>
      <div className="sla-row__icon" aria-hidden="true">
        {sla.icon}
      </div>
      <div className="sla-row__main">
        <div className="sla-row__title">{sla.label}</div>
        <div className="sla-row__sub mono">
          SLA: {sla.slaLabel} · Cumprimento:{' '}
          <b style={{ color: ok ? 'var(--success-fg)' : 'var(--warning-fg)' }}>
            {sla.cumprimento}%
          </b>{' '}
          {ok ? '✓' : '⚠'}
        </div>
        <div className="sla-row__detail">
          {sla.total} demandas · {sla.withinSla} dentro · {sla.violations} violações
        </div>
      </div>
      <div className="sla-row__bar">
        <div
          className="sla-row__bar-fill"
          style={{
            width: sla.cumprimento + '%',
            background: ok ? 'var(--success-fg)' : 'var(--warning-fg)',
          }}
        />
        <span
          className="sla-row__bar-threshold"
          style={{ left: sla.threshold + '%' }}
          title={`Mínimo ${sla.threshold}%`}
        />
      </div>
      <button type="button" className="btn-ghost-mini" onClick={() => onDrill?.(sla)}>
        Ver violações →
      </button>
    </div>
  );
}
